<template lang="pug">
div
  crud-scroll-details.pa-2(
    ref="list"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :filters="filters"
  )
    template(#list-header="{ init, unSelect, resetSearch }")
      v-row.mb-4
        v-col.pa-0
          v-btn.pr-n5(
            block tile depressed
            :color="tab === 0 ? 'secondary' : ''"
            @click="tab = 0; resetSearch(); unSelect(); "
          ) Практики
        v-col.pa-0
          v-btn.pl-n5(
            block tile depressed
            :color="tab === 1 ? 'secondary' : ''"
            @click="tab = 1; resetSearch(); unSelect(); "
          ) Программы

    template(#list-item="{ item }")
      v-list-item-content
        v-list-item-title {{ item.title || item.id }}
        v-chip-group
          v-chip(
            v-for="i in item.tags"
            :key="i.id"
            :color="i.color"
            :class="{ 'white--text': invertColor(i.color) }"
            small
          ) {{ i.name }}
    template(#no-select)
      div
        v-alert(type="info" outlined) Выберите элемент списка для детального отображения
        .d-flex(v-if="tab === 0")
          v-btn(color="primary" outlined @click="createPractice").ml-auto Создать новую практику
            v-icon mdi-plus
        .d-flex(v-else)
          v-btn(color="primary" outlined @click="showCreateProgram").ml-auto Создать новую программу
            v-icon mdi-plus
  portal(to="program.dialog" v-slot="{ close, attrs }")
    v-card.sdo-card
      v-card-title Выберите курс из списка
      v-card-text
        api-form(
          v-model="data"
          v-bind="props"
          :method="createProgram"
          :successCallback="successCallback"
        )
</template>
<script>
import { invertColor } from '@/utils/color-functions';
import SelectCourse from '@/components/InputFields/course/SelectCourse.vue';

import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import PracticeCard from '../components/recommendation/RecomendationListDetail.vue';
import TagsList from '../components/TagsList.vue';

export default {
  components: {
    CrudScrollDetails,
    TagsList,
  },
  props: {
  },
  data() {
    return {
      invertColor,
      tab: 0,
      data: {},
    };
  },
  computed: {
    filters() {
      return [
        {
          key: 'search[tag_id]',
          component: TagsList,
          component_attrs: {
            filled: true,
            multiple: true,
            'return-object': false,
            rounded: true,
            label: 'Наименование программы',
          },
        },
      ];
    },
    props() {
      return {
        'btn-props': {
          btnText: 'Сохранить',
        },
        fields: [
          {
            text: 'Наименование программы',
            value: 'title',
            rules: 'required',
            component: 'v-text-field',
            component_attrs: {
              filled: true,
              rounded: true,
            },
          },
          {
            text: 'Описание',
            value: 'description',
            component: 'v-textarea',
            component_attrs: {
              filled: true,
              rounded: true,
            },
          },
          {
            component: 'v-select',
            text: 'Тип курса',
            value: 'type',
            component_attrs: {
              rounded: true,
              filled: true,
              items: [{ value: 0, text: 'Внутренний курс' }, { value: 1, text: 'Внешний курс' }],
            },
          },
          ...Object.hasOwn(this.data, 'type') ? [{
            ...this.data.type === 0 ? {
              component: SelectCourse,
              rules: 'required',
              value: 'course',
              component_attrs: {
                rounded: true,
                filled: true,
              },
            } : {
              text: 'Ссылка на внешний курс',
              value: 'link',
              rules: 'required',
              component: 'v-text-field',
              component_attrs: {
                filled: true,
                rounded: true,
              },
            },
          }] : [],
        ],
      };
    },
    detailsComponent() {
      return {
        component: PracticeCard,
        component_attrs: {},
      };
    },
    method() {
      return this.tab === 0
        ? this.$api.mentoring.getResources : this.$api.mentoring.getRecommendations;
    },
  },
  methods: {
    createProgram({ data }) {
      const payload = {
        ...data,
        course_id: data.course.id,
      };
      delete payload.course;
      return this.$api.mentoring.createRecommendationPage(payload);
    },
    successCallback({ data }) {
      this.$refs.list.selectById(data.data.id);
      this.$modals.close();
    },
    async createPractice() {
      const params = {
        is_active: true,
      };
      const { data } = await this.$api.mentoring.createResource(params);
      this.$router.push({ name: 'ResourceDetailEdit', params: { id: data.data.id } });
    },
    async showCreateProgram() {
      this.$modals.show('dialog-portal', {
        dialogProps: {
          width: 800,
        },
        inputValue: 'program',
      });
    },
    adapter(params) {
      const extendParams = {
        expand: 'cards,tags',
        ...this.tab === 0 ? { 'search[is_for_course]': 0 } : {},
        ...params,
      };
      return this.method(extendParams);
    },
  },
};
</script>
